module.exports = __webpack_public_path__ + "img/2.e3b6cf1f.jpg";